var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knowledge-base"},[_c('knowledge-nav'),_vm._v(" "),_c('black-list'),_vm._v(" "),_c('posts-main-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }